<template>
  <div class="d-flex table-container">
    <table class="mark-table">
      <thead>
        <tr>
          <th rowspan="2">STT</th>
          <th rowspan="2">Học sinh</th>
          <th rowspan="2">Ngày sinh</th>
          <th class="semseter-header" v-for="semester in semesters" :key="semester.id" :colspan="semester.maxColumn">
            {{ semester.title }}
          </th>
        </tr>
        <tr>
          <td v-for="factor in factors" :key="factor.id" :colspan="factor.maxColumn">
            {{ factor.title }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, order) in studentMarks" :key="item.id">
          <td>{{ order + 1 }}</td>
          <td class="px-2 py-0" style="text-align: left"><CardStudentName :student="item.student" link /></td>
          <td>{{ item.student.dob | ddmmyyyy }}</td>

          <td v-for="mark in item.marks" :key="mark.id">
            <span v-if="subject.markType === 'mark'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div style="width: 40px">
                    <span v-bind="attrs" v-on="on">
                      {{ mark.value }}
                    </span>
                  </div>
                </template>
                <span>{{ mark.date | ddmmyyyy }}</span>
              </v-tooltip>
            </span>
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div style="width: 70px">
                    <span style="white-space: nowrap" v-bind="attrs" v-on="on">
                      {{ mark.value | getEvaluate }}
                    </span>
                  </div>
                </template>
                <span>{{ mark.date | ddmmyyyy }}</span>
              </v-tooltip>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: { CardStudentName },
  computed: {
    ...mapState('ClassMark', ['studentMarks', 'factors', 'semesters', 'subject'])
  },
  methods: {
    ...mapActions('ClassMark', ['fetchClassMarks']),
    async refresh(query) {
      this.$loading.active = true
      try {
        await this.fetchClassMarks(query)
      } catch (error) {
        console.error(error)
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.mark-table {
  td,
  tr,
  th {
    border: 1px solid #e0e0e0;
  }
  td,
  th {
    padding: 14px 20px;
    text-align: center;
  }
  .semseter-header {
    font-size: 20px;
    color: #0d47a1;
    text-transform: uppercase;
  }
  color: #212121;
  border-collapse: collapse;
  width: 100%;
}
.table-container {
  overflow: auto;
  max-width: 100%;
}
</style>
